import { CheckCircle, ArrowLeft, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useNavigate } from "react-router-dom";

const Success = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-background to-secondary/20 flex items-center justify-center p-4">
      <Card className="w-full max-w-md mx-auto shadow-lg border-0 bg-card/80 backdrop-blur-sm">
        <CardContent className="p-8 text-center space-y-6">
          <div className="relative">
            <div className="absolute inset-0 animate-ping">
              <CheckCircle className="w-20 h-20 text-primary/30 mx-auto" />
            </div>
            <CheckCircle className="w-20 h-20 text-primary mx-auto relative z-10" />
          </div>
          
          <div className="space-y-2">
            <h1 className="text-3xl font-bold text-foreground flex items-center justify-center gap-2">
              Thank You! <Sparkles className="w-6 h-6 text-primary" />
            </h1>
            <p className="text-muted-foreground text-lg">
              Your purchase was successful
            </p>
          </div>
          
          <div className="bg-primary/5 rounded-lg p-4 border border-primary/10">
            <p className="text-sm text-muted-foreground">
              Your account has been upgraded. If you need any help, contact support@aihumanizertext.com
            </p>
          </div>
          
          <div className="space-y-3 pt-4">
            <Button 
              onClick={() => navigate("/")}
              className="w-full"
              size="lg"
            >
              Continue to Dashboard
            </Button>
            
            <Button 
              variant="outline" 
              onClick={() => navigate(-1)}
              className="w-full"
              size="lg"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Go Back
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Success;